import { useState } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { AboutPeeModal } from "./AboutPeeModal";
import { PEE_ARIA, PEE_FULL_NAME, PEE_SIDEBAR_NOTE } from "@/lib/looseend/pee";
import { cn } from "@/lib/utils";

/**
 * Understated sidebar label sitting beneath the L∞seEnd™ wordmark and its
 * Personal Execution System descriptor.
 * Keyboard accessible: focus reveals the tooltip, Enter opens the About modal.
 */
export function PoweredByPee({ className }: { className?: string }) {
  const [about, setAbout] = useState(false);

  return (
    <>
      <TooltipProvider delayDuration={150}>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              onClick={() => setAbout(true)}
              aria-label={`Powered by ${PEE_ARIA}. About the engine.`}
              className={cn(
                "rounded text-[11px] text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                className,
              )}
            >
              Powered by <span className="text-primary">PEE™</span>
            </button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="max-w-[240px]">
            <span className="block font-semibold">PEE™</span>
            <span className="block">{PEE_FULL_NAME}</span>
            <span className="mt-1 block">{PEE_SIDEBAR_NOTE}</span>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <AboutPeeModal open={about} onOpenChange={setAbout} />
    </>
  );
}
